import React, { useState, useEffect } from 'react';
import { SiteContentWrapper } from './SiteContentWrapper';
import "./HelloWorld.scss";

export const HelloWorld: React.FC = () => {
    const [ message, setMessage ] = useState<string>(null);

    useEffect(() => {
        fetch('/api/hello')
            .then((result) => {
                result.json().then((v) => {
                    setMessage(v.message);
                });
            });
    }, []);

    return (
        <SiteContentWrapper
            content={message}
            options={{
                overrides: {
                    ul: {
                        props: {
                            className: 'tile-collection'
                        }
                    },
                    li: {
                        props: {
                            className: 'tile'
                        }
                    }
                }
            }}
        />
    );
}